"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _a;

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var utils = require("@headspace/hs-web-style-guide/dist/utils");

var spacing = require("@headspace/hs-web-style-guide/dist/spacing");

var text = require("@headspace/hs-web-style-guide/dist/text-utils");

var breakpoints = require("@headspace/hs-web-style-guide/dist/breakpoints");

var badge = hs_web_style_guide_1.css((_a = {
  width: '155px'
}, _a[breakpoints.maxWidths.m] = {
  width: '100%'
}, _a));

function FooterListItem(props) {
  var href = props.href,
      linkText = props.linkText,
      src = props.src;
  return React.createElement("li", __assign({}, spacing.default.marginTopSmall), React.createElement("a", __assign({
    href: href
  }, hs_web_style_guide_1.css(utils.default.textDecorationNone), text.default.linkHover, text.default.cometColor), src ? React.createElement("img", __assign({}, badge, {
    src: src
  })) : linkText));
}

exports.FooterListItem = FooterListItem;